export const CONTACT_PHONE_PATTERN = /^\+[1-9]\d{6,14}$/;

export interface ProfileRebindFormValues {
  contact_phone?: string;
}

export interface ProfileRebindState {
  loading: boolean;
  submitting: boolean;
  initialPhone: string;
}
